module.exports = __webpack_public_path__ + "static/media/BloodsInvestigations.72ebf100.png";